<template>
  <div :class='["event", isFrame && "framed"]'>
    <div class="container" id="container">
      <div class="d-flex p-2 justify-content-center align-items-center" v-if="!event">
        <div class="focus">
          <div class="focus--mask">
            <div class="focus--mask-inner">QUICKLY</div>
          </div>
        </div>
      </div>
      <div class="row eventContainer m-0" v-if="event">
        <div class="col-12 col-sm-12 col-md-6 mt-5 mb-5 mt-sm-auto mb-sm-auto" v-show="!isFrame">
          <div class="intro text-center text-sm-left">
            <img :src=" imagePath  + image" alt="" class="eventImg" v-if="image">
            <h2 v-if="!dateTimeEventChecked">
              {{ event.description }}
            </h2>
          </div>
          <ul class="detail-list">
            <li class="detail-clock">{{ event.incrementTime }} Min</li>
            <li class="detail-call" v-if="dateTimeEventChecked">{{ $t('member_team_consultation') }}
            </li>
            <li class="detail-calendar" style="color: #55b9e7;" v-if="dateTimeEventChecked">

              {{ getWeekDay(dateTimeEventChecked.date) }} {{ getDateString(dateTimeEventChecked.date) }},
              {{ dateTimeEventChecked.hour }} -
              {{ getLocalEndingTime() }}

            </li>
            <li class="detail-globe">
              {{ getTimeZone(selectedTZ) }}
            </li>
          </ul>
        </div>
        <div :class="{'col-12 col-sm-12 col-md-6': !isFrame, 'col-sm': isFrame, 'slideContainer': true, goingBack: isGoingBack}">
          <!-- Calendar and hours range-->
          <transition name="modernSlide">

            <div class="min-size p-3 bg-white rounded-lg slideBlock" key="sub1"
                 style="color: #8d8d8d" v-if="!date">
              <div>
                <h4 style="margin-bottom: 10px;">{{ $t('select_day_time') }}</h4>
                <DatePicker
                    :attributes='datePickerAttributes' :disabled-dates='excludeDates'
                    :from-date='startDateCalendar'
                    :locale="lang"
                    :theme="theme"
                    is-expanded is-inline title-position="left" v-model='date'/>
              </div>
            </div>

            <div class="min-size p-3 bg-white rounded-lg slideBlock" key="sub2"
                 style="color: #8d8d8d" v-else-if="!dateTimeEventChecked">
              <a @click="date = null" class="back-btn mb-2" href="#"><i class="fas fa-arrow-left"></i></a>
              <div class="row m-0 p-0 justify-content-center">
                <Select2 :options="loadTimeZoneList" class="col-6 select2-custom"
                         v-model="selectedTZ"/>
              </div>
              <h4> {{ $t('select_time') }} </h4>
              <div>
                <button class="btn btn-primary btn-sm"
                        style="background-color: #d5eefa!important;border: none"
                        type="button"></button>
                <span style="font-size: 11px"> {{ $t('available slots') }}  </span>
                <button class="btn btn-primary btn-sm"
                        style="background-color: #dbdbdb!important;border: none"
                        type="button"></button>
                <span style="font-size: 11px"> {{ $t('unavailable slots') }}</span>
              </div>
              <div :class="{'text-center': loadingTimeranges}" class="qck-hours-container">
                <template v-if="loadingTimeranges">
                  <i class="fas fa-circle-notch fa-spin"
                     style="margin: 0 auto;font-size: 40px;"></i>
                </template>
                <template v-else>
                  <div class="scrollbar">
                    <template v-if="timeranges.length > 0">
                      <div :key="timerange.itemId" class="hours" v-for="timerange in timeranges">
                        <a :class="buttonHourActif"
                           v-if="timerange.enabled && timerange.startDate != hour"
                           v-on:click="setHour(timerange.startDate)">{{ getHourMinute(timerange.startDate) }} </a>
                        <a :class="buttonHourActifChecked"
                           v-else-if="timerange.enabled && timerange.startDate == hour"
                           v-on:click="setHour(timerange.startDate)">{{ getHourMinute(timerange.startDate) }} </a>
                        <a :class="buttonHourInactif"
                           v-else>{{ getHourMinute(timerange.startDate) }} </a>
                      </div>
                    </template>
                    <template v-else>
                      <p class="text-center">{{ $t('no_timeranges_found')}}</p>
                    </template>
                  </div>
                </template>
              </div>
              <br>
              <div class="text-center">
                <button :disabled="!date || !hour" class="qck-btn" style="background-color: #9ac455" type="button"
                        v-on:click="validateDateTime()">{{ $t('Next') }}
                </button>
              </div>
            </div>

            <div class="min-size p-3 bg-white rounded-lg slideBlock" style="color: #8d8d8d"
                 v-else-if="!confirmationRdv && !firstFormSubmitted" key="sub3">
              <div>
                <form>
                  <a @click="dateTimeEventChecked = null" class="back-btn mb-2" href="#"
                     v-show="!disableFields"><i
                      class="fas fa-arrow-left"></i></a>
                  <h4>{{ $t('contact_form_title') }}</h4>

                  <div class="form-row mb-1">
                    <div class="form-group col-md-6">
                      <label for="prenom">{{ $t('Last Name') }}*</label>
                      <input :disabled="disableFields" class="form-control" id="prenom" required
                             type="text" v-model="item.firstname"/>
                    </div>
                    <div class="form-group col-md-6">
                      <label for="nom">{{ $t('First Name') }}*</label>
                      <input :disabled="disableFields" class="form-control" id="nom" required
                             type="text" v-model="item.lastname"/>
                    </div>
                  </div>
                  <div class="form-row mb-1">
                    <div class="form-group col-md-12">
                      <label for="email">{{ $t('Email address') }}*</label>
                      <input :disabled="disableFields" class="form-control" id="email" required
                             type="text" v-model="item.email"/>
                    </div>
                  </div>
                  <br>
                  <div class="text-center">
                    <button :disabled="disableFields || !firstFormCompleted" class="qck-btn" style="background-color: #9ac455" type="button"
                            v-on:click="checkFirstFormInput()">{{ $t('Next') }}
                    </button>
                  </div>
                </form>
              </div>
            </div>
            <div class="min-size p-3 bg-white rounded-lg slideBlock" v-else-if="!confirmationRdv">
              <form>
                <a @click="firstFormSubmitted = false" class="back-btn mb-2" href="#"
                   v-show="!disableFields"><i
                    class="fas fa-arrow-left"></i></a>
                <h4>{{ $t('contact_form_title') }}</h4>

                <div class="form-group">
                  <label for="comment" v-if="!note">{{ $t('contact_form_comment') }}</label>
                  <label for="comment" v-else>{{ note }}</label>
                  <textarea :disabled="disableFields" class="form-control" id="comment" rows="3"
                            v-model="item.comment"></textarea>
                </div>

                <div class="card mb-3 container mt-4"
                     style="background-color: #54b9e7;border-radius:8px; padding: 10px; border: none">
                  <div class="form-group col-md-12">
                    <label class="text-white" for="phone">{{ $t('Phone number') }} *</label>
                    <vue-phone-number-input :default-country-code=indicative :disabled="disableFields"
                                            :preferred-countries=prefered_indicatives
                                            :translations="{countrySelectorLabel:
                                                                $t('Country Code') ,countrySelectorError:
                                                                $t('Choose a country'),phoneNumberLabel: $t('Phone'),example: $t('Example') + ' :'}"
                                            id="phone"
                                            required
                                            @update="internationalPhoneNumber = $event.formatInternational"
                                            v-model="item.phone"/>
                  </div>
                </div>

                <div class="card container border-0">
                  <div class="form-group col-md-12">
                    <input class="form-check-input" id="contactAuth" type="checkbox"
                           v-model="item.contactAuth">
                    <label class="form-check-label " for="contactAuth"
                           style="font-size: 11px">* {{ $t('agreement') }}</label>

                  </div>
                </div>
                <div class="text-center">
                  <button :disabled="disableFields || !secondFormCompleted" class="qck-btn"
                          style="background-color: #9ac455"
                          type="button"
                          v-on:click="createClientEvent()"><span v-show="!disableFields">{{ $t('Confirm') }}</span><i
                      class="fas fa-spinner fa-spin" v-show="disableFields"></i>
                  </button>
                  <div class="p-2 text-danger text-center" style="font-size: 12px;" v-if="problem">
                    {{ $t('error_registering_appointment') }}<br>
                    {{ $t('check_available_time_slots') }}<br>
                    {{ $t('Thanks') }}
                  </div>
                </div>
              </form>
            </div>
            <div class="min-size p-3 bg-white rounded-lg slideBlock" style="color: #8d8d8d" v-else key="sub4">
              <br><br>
              <div class="center">
                <img class="mx-auto d-block w-2" src="../assets/img/confirm-button.png" width="62">
              </div>
              <div class="text-center mt-3 mb-3">
                {{ $t('confirm_sent_email') }}
              </div>
              <div class="text-center mt-3 mb-5">
              </div>

              <div class="mt-3">
                <img class="mx-auto d-block w-20" src="../assets/img/calendar.png">
              </div>

              <div class="text-center mt-1 mb-5" style="color: #54b9e7">
                {{ $t('appointment_confirmed') }}
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment-timezone'
import Select2 from 'v-select2-component';
import DatePicker from 'v-calendar/lib/components/date-picker.umd'
import {api, imagePath, cognitoCredentials, cognitoApp} from '../../config';

export default {
  metaInfo() {
    return {
      title: this.lang === "en" ? "A member of the team will call you back for free consultation": "Notre équipe vous rappelle gratuitement",
    }
  },
  components: {
    //Calendar,
    DatePicker,
    Select2
  },
  name: 'Event',
  props: {
    isFrame: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      selectedTZ: null,
      imagePath: imagePath,
      cognitoCredentials: cognitoCredentials,
      cognitoApp: cognitoApp,
      accessToken: "",
      eventSlug: "",
      event: null,
      eventDates: [],
      timeranges: [],
      startDateCalendar: "",
      lang: "",
      date: null,
      hour: null,
      note: null,
      disableFields: false,
      problem: false,
      loadingTimeranges: false,
      buttonHourActif: 'hours-open left',
      buttonHourActifChecked: 'hours-checked left',
      buttonHourInactif: 'hours-disabled left disable',
      dateTimeEventChecked: null,
      firstFormSubmitted: false,
      item: {
        startDate: null,
        incrementTime: null,
        firstname: null,
        lastname: null,
        email: null,
        comment: null,
        phone: null,
        eventId: null,
        image: null
      },
      image: null,
      confirmationRdv: false,
      theme: {
        title: {
          light: " qck-month vc-text-lg text-style--dark hover:vc-opacity-75",
        },
        container: {
          light: "qck-container",
        },
        weekdays: {
          light: "qck-weekday",
        },
        dayContent: "qck-day-content",
        dayContentDisabled: {
          light: 'qck-day-content-disabled',

        },
      },
      indicative: "FR",
      prefered_indicatives: ["FR", "GB", "US"],
      internationalPhoneNumber: null,
      isGoingBack: false,
    }
  },
  computed: {
    firstFormCompleted() {
      return !!(this.item.firstname && this.item.lastname && this.item.email);
    },
    secondFormCompleted() {
      return !!(this.firstFormCompleted && this.item.phone && this.item.contactAuth);
    },
    datePickerAttributes() {
      return [{
        highlight: {
          backgroundColor: '#ff8080', // Red
          borderColor: '#ff6666',
          borderWidth: '2px',
          borderStyle: 'solid',
        },
        contentStyle: {
          color: 'white',
        },
        dates: this.eventDates
      }];
    },
    excludeDates() {
      let startDate = new Date(this.event.startDate);
      let today = new Date();
      if (startDate > today) {
        startDate.setDate(startDate.getDate() - 1);
      } else {
        today.setDate(today.getDate() - 1);
        startDate = today;
      }

      let endDate = new Date(this.event.endDate);
      endDate.setDate(endDate.getDate() + 1);
      return [
        // Use date ranges
        {
          start: new Date(1900, 0, 1),
          end: startDate,
        },
        {
          start: endDate,
          end: new Date(3000, 11, 31),
        },
        // Or single dates
        //new Date(2019, 11, 28),
        //new Date(2019, 11, 29),
      ];
    },
    loadTimeZoneList() {
      let timeZones = moment.tz.names();
      let listTimeZones = [];
      timeZones.forEach((timeZone, index) => {
        listTimeZones[index] = {
          "text": `${timeZone} (GMT${moment.tz(timeZone).format('Z')})`,
          "id": timeZone
        };
      });
      return listTimeZones;
    },
    step() {
      let res = 0;
      for(let key of ['date', 'dateTimeEventChecked', 'firstFormSubmitted', 'confirmationRdv']) {
        if (this[key])
          res++;
        else
          break;
      }
      return res;
    }
  },
  created() {
    switch (this.$route.params.slug) {
      case 'mcd':
        window.location.replace("https://meetings.hubspot.com/greenbull/mcd" + ((this.isFrame) ? "?embed=true" : ""));
        break;
      case 'n-g':
        window.location.replace("https://meetings.hubspot.com/greenbull/n-g" + ((this.isFrame) ? "?embed=true" : ""));
        break;
      case 'cercleCF':
        window.location.replace("https://meetings.hubspot.com/greenbull/cerclecf" + ((this.isFrame) ? "?embed=true" : ""));
        break;
      case 'formation-locaux-pro-gbp':
        window.location.replace("https://meetings.hubspot.com/greenbull/formation-locaux-pro-gbp" + ((this.isFrame) ? "?embed=true" : ""));
        break;
      case 'formetoi':
        window.location.replace("https://meetings.hubspot.com/greenbull/formetoi" + ((this.isFrame) ? "?embed=true" : ""));
        break;
      case 'afb':
        window.location.replace("https://meetings.hubspot.com/greenbull/afb" + ((this.isFrame) ? "?embed=true" : ""));
        break;
      case 'olivier-bruce':
        window.location.replace("https://meetings.hubspot.com/greenbull/olivier-bruce" + ((this.isFrame) ? "?embed=true" : ""));
        break;
      case 'tardi44':
        window.location.replace("https://meetings.hubspot.com/greenbull/tardi44" + ((this.isFrame) ? "?embed=true" : ""));
        break;
      case 'f-v':
        window.location.replace("https://meetings.hubspot.com/greenbull/f-v" + ((this.isFrame) ? "?embed=true" : ""));
        break;
      case 'formation-cpf-entreprendre-aff':
        window.location.replace("https://meetings.hubspot.com/greenbull/formation-cpf-entreprendre-aff" + ((this.isFrame) ? "?embed=true" : ""));
        break;
      case 'mepartner':
        window.location.replace("https://meetings.hubspot.com/greenbull/mepartner" + ((this.isFrame) ? "?embed=true" : ""));
        break;
      case 'enfin_rentable-agent_immo':
        window.location.replace("https://meetings.hubspot.com/greenbull/intermediaire-immobilier" + ((this.isFrame) ? "?embed=true" : ""));
        break;
      case 'enfin_rentable-air-so-ac':
        window.location.replace("https://meetings.hubspot.com/greenbull/sam-ovens" + ((this.isFrame) ? "?embed=true" : ""));
        break;
      case 'enfin_rentable-rdv-tel-gmb':
        window.location.replace("https://meetings.hubspot.com/greenbull/googlemybusiness" + ((this.isFrame) ? "?embed=true" : ""));
        break;
      case 'enfin-rentable-rdv-tel':
        window.location.replace("https://meetings.hubspot.com/greenbull/greenbull-campus" + ((this.isFrame) ? "?embed=true" : ""));
        break;
      case 'formation-cpf':
      case 'enfin_rentable-rendez_vous-cpf-air':
      case 'tdv-pack-decouverte-immo-client':
      case 'tdv-pack-decouverte-immo-orga':
      case 'tdv-pack-decouverte-immo-paid':
        window.location.replace("https://meetings.hubspot.com/greenbull/immobilier" + ((this.isFrame) ? "?embed=true" : ""));
        break;
      case 'formation-cpf-entreprendre':
        window.location.replace("https://meetings.hubspot.com/greenbull/entrepreneuriat" + ((this.isFrame) ? "?embed=true" : ""));
        break;
      case 'formation-locaux-pro':
        window.location.replace("https://meetings.hubspot.com/greenbull/locaux-professionnels" + ((this.isFrame) ? "?embed=true" : ""));
        break;
      case 'prelancement-rendez-vous-greenbull-campus':
        window.location.replace("https://meetings.hubspot.com/greenbull/pre-lancement" + ((this.isFrame) ? "?embed=true" : ""));
        break;
      case 'rdv-enfinrentable':
        window.location.replace("https://meetings.hubspot.com/greenbull/reseaux-sociaux" + ((this.isFrame) ? "?embed=true" : ""));
        break;
      case 'rdv-financement':
        window.location.replace("https://meetings.hubspot.com/greenbull/fb-financement" + ((this.isFrame) ? "?embed=true" : ""));
        break;
      case 'rdv-team-er':
        window.location.replace("https://meetings.hubspot.com/greenbull/immobilier" + ((this.isFrame) ? "?embed=true" : ""));
        break;
      default:
        break;
    }
    let $this = this;
    this.getCognitoAccessToken();
    this.selectedTZ = moment.tz.guess();
    $this.eventSlug = $this.$route.params.slug;

    if ($this.isFrame) {
      document.body.classList.add('removebg');
    }

    axios.get(api.url + 'event/slug/' + $this.eventSlug)
        .then(response => {
          if (response.data && $this.eventSlug.indexOf("canceled") < 0) {
            let eventData = response.data;
            axios.get(api.url + 'event/dates/' + eventData.itemId)
                .then(response => {
                  if (response.data) {
                    $this.event = eventData;
                    $this.image = $this.event.image;
                    $this.eventDates = [ (moment().format("YYYY-MM-DD") + ''), ...response.data];
                    $this.note = $this.event.note;
                    $this.$i18n.locale = ($this.event.language) ? $this.event.language : 'fr';
                    $this.lang = ($this.event.language) ? $this.event.language : 'fr';

                    if ($this.event.language === 'fr') {
                      this.indicative = "FR"
                      this.prefered_indicatives = ['FR', 'GB', 'US']
                    } else if ($this.event.language === 'en') {
                      this.indicative = "GB"
                      this.prefered_indicatives = ['GB', 'US', 'FR']
                    }

                    let startDate = new Date(this.event.startDate);
                    let today = new Date();

                    if (startDate > today) {
                      this.startDateCalendar = startDate;
                    } else {
                      // this.startDateCalendar = moment().add(1, "day").toDate();
                      this.startDateCalendar = moment().add(0, "day").toDate();
                    }
                  }
                })
                .catch(error => {
                  return error;
                });

          } else if (response.data && $this.eventSlug.indexOf("cancelation") > 0) {
            this.$router.push({
              name: 'Canceled'
            });
          } else {
            this.$router.push({
              name: 'NotFound'
            });
          }
        })
        .catch(error => {
          console.log(error);
          return error;
        });
  },

  watch: {
    date(nextDate) {
      this.emitEvent({type: 'date_chosen'});
      this.loadingTimeranges = true;
      this.timeranges = [];
      let date = this.getDate(nextDate);
      this.hour = null;
      axios.get(api.url + 'timeranges?eventId=' + this.event.itemId + '&date=' + date)
          .then(response => {
            if(this.date !== nextDate) // Date changed in the mean time! May happen if the user changes date quickly (or if the backend takes ages to reply)
              return;
            this.timeranges = response.data.filter(t => t.enabled);
            this.loadingTimeranges = false;
            window.scrollTo(0, document.body.scrollHeight);
            this.emitEvent({type: 'fetched_hours', count: response.data?.length});
          })
          .catch(error => {
            console.log(error);
            this.loadingTimeranges = false;
            return error;
          })
    },
    secondFormCompleted(nextVal, prevVal) {
      if (nextVal && !prevVal)
        this.emitEvent({type: "form_completed"});
    },
    step(nextVal, prevVal) {
      this.isGoingBack = nextVal < prevVal;
    }
  },
  methods: {
    getDateString(value) {
      const parsedDate = moment(value);
      return parsedDate.locale(this.lang).format('LL');
    },

    getWeekDay(value) {
      let day = moment(value).locale(this.lang).format('dddd')
      return day
    },

    getHourMinute(value) {
      let time;
      if (this.lang === 'fr') {
        time = moment(this.timezoneDateTimeDiff(value)).format('H:mm');
      } else if (this.lang === 'en') {
        time = moment(this.timezoneDateTimeDiff(value)).format('h:mm a');
      }
      return time;
    },

    getDate(value) {
      return moment(value).format('Y-MM-DD')
    },
    setHour(value) {
      this.hour = value;
      this.emitEvent({
        type: 'hour_chosen',
      });
    },
    checkFirstFormInput() {
      this.firstFormSubmitted = true;
    },

    validateDateTime() {
      if (this.date && this.hour) {
        this.dateTimeEventChecked = {
          date: this.getDate(this.date),
          hour: this.getHourMinute(this.hour)
        }
        this.item.startDate = this.hour;
        this.item.incrementTime = this.event.incrementTime;
        this.item.eventId = this.event.itemId;
        window.scrollTo(0, 0);
        this.emitEvent({
          type: 'date_and_hour_chosen',
        });
      }
    },

    getLocalEndingTime() {
      let val = moment.utc(this.hour).clone().add(this.event.incrementTime, 'minutes');
      if (this.lang === 'fr')
        return val.tz(this.selectedTZ).format('H:mm');
      return  val.tz(this.selectedTZ).format('h:mm a');
    },
    createClientEvent() {
      if (this.secondFormCompleted) {
        this.disableFields = true;
        this.problem = false;
        this.item.timezone = this.selectedTZ;
        this.item.image = this.image;
        this.item.phone = this.internationalPhoneNumber ? this.internationalPhoneNumber : this.item.phone;
        this.emitEvent({type: 'create_event'});
        axios.post(api.url + 'client', this.item,
            {
              headers: {
                'Content-Type': 'application/json',
                'Authorization': this.accessToken
              }
            })
            .then(response => {
              this.confirmationRdv = true;
              this.disableFields = false;
              this.emitEvent({type: 'event_created'});
              return response.data;
            })
            .catch(error => {
              console.log(error);
              this.problem = true;
              this.disableFields = false;
              return error;
            });
      }
    },
    timezoneDateTimeDiff(time) {
      let utcDate = moment.utc().format();
      let localDate = moment().tz(this.selectedTZ).format();

      if (utcDate !== localDate) {
        return moment.utc(time).tz(this.selectedTZ).format("YYYY-MM-DD HH:mm");
      }

      return time;
    },

    getTimeZone(timez) {
      return timez + "(GMT" + moment.tz(timez).format('Z') + ")";
    },
    getCognitoAccessToken() {
      axios.post(this.cognitoApp, '',
          {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
              'AuthFlow': 'REFRESH_TOKEN_AUTH'
            },
            auth: this.cognitoCredentials
          })
          .then(response => {
            this.accessToken = response.data.access_token;
          })
          .catch(error => {
            console.log(error);
            return error;
          })
    },
    emitEvent({type, ...otherData}) {
      try {
        if (!this.isFrame || !window.parent)
          return;
        const data = {
          eventId: this.eventSlug,
          event: 'quickly_' + type,
          ...otherData,
        };
        if (this.hour)
          data.hour = this.hour;
        if (this.date)
          data.date = this.date.toISOString().split('T')[0];
        window.parent.postMessage({
          type: 'quicklyEvent',
          data,
        }, '*');
      } catch (e) { // Make sure we don't crash the app
        console.warn(e);
      }
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

@-webkit-keyframes mask-move {
  0% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }
  100% {
    -webkit-transform: translateX(189px);
    transform: translateX(189px);
  }
}

@keyframes mask-move {
  0% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }
  100% {
    -webkit-transform: translateX(189px);
    transform: translateX(189px);
  }
}

@-webkit-keyframes mask-inner-move {
  0% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }
  100% {
    -webkit-transform: translateX(-189px);
    transform: translateX(-189px);
  }
}

@keyframes mask-inner-move {
  0% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }
  100% {
    -webkit-transform: translateX(-199px);
    transform: translateX(-189px);
  }
}

.focus {
  color: black;
  font-size: 3rem;
  text-transform: uppercase;
  letter-spacing: .2rem;
  line-height: 1;
  position: relative;
  width: 239px;
}

.focus:before {
  content: 'QUICKLY';
  -webkit-filter: blur(3px);
  filter: blur(3px);
}

.focus:after {
  content: '';
  position: absolute;
  width: 50px;
  height: calc(100% + 8px);
  top: -4px;
  left: 0;
  border-top: 1px solid;
  border-bottom: 1px solid;
  -webkit-animation: mask-move 1s linear infinite alternate;
  animation: mask-move 1s linear infinite alternate;
}

.addOverFlow {
  overflow: hidden;
}

.focus--mask {
  overflow: hidden;
  position: absolute;
  width: 50px;
  height: 100%;
  top: 0;
  left: 0;
  background: #fff;
  -webkit-animation: mask-move 1s linear infinite alternate;
  animation: mask-move 1s linear infinite alternate;
}

.focus--mask-inner {
  -webkit-animation: mask-inner-move 1s linear infinite alternate;
  animation: mask-inner-move 1s linear infinite alternate;
}
</style>

<style>
.select2-custom span.select2 .selection .select2-selection {
  border-radius: 0 !important;
  border: 0;
  font-size: 12px;
  text-align: center;
}

.select2-custom span.select2 .selection .select2-selection::before {
  font-weight: 900;
  font-family: "Font Awesome 5 Free";
  content: "\f0ac";
  color: #8d8d8d;
  margin-right: 8px;
  position: absolute;
  left: -10px;
  top: 5px;
}

.select2-search__field {
  color: #8d8d8d;
  border-color: #8d8d8d;;
}

.select2-results {
  color: #8d8d8d;
  font-size: 12px;
}

.select2-dropdown {
  border: 0;
}

.scrollbar {
  height: 180px;
  width: 100%;
  overflow-y: scroll;
  display: flex;
  flex-wrap: wrap;
}

.eventImg {
  max-width: 300px;
  width: 90%; /* Make sure we are not too large for the container */
}

@keyframes slide {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(-100%, 0);
  }
}
@keyframes slide-back {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(100%, 0);
  }
}
@keyframes slide-back-other {
  0% {
    transform: translate(-200%, 0);
  }
  100% {
    transform: translate(-100%, 0);
  }
}

@keyframes slide-opacity {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes slide-margin {
  0% {
    margin-right: 0;
  }
  100% {
    margin-right: 20px;
  }
}
.modernSlide-enter-active {
  animation: slide ease-out .2s, slide-opacity linear .2s, slide-margin linear .2s;
}

.modernSlide-leave-active {
  animation: slide ease-in .2s, slide-opacity reverse linear .2s, slide-margin reverse linear .2s;
}
.slideContainer{
  flex-direction: row;
  align-items: center;
  display: flex;
}
.slideBlock {
  min-width:100%;
  flex:0;
  margin-right: 20px;
}
.goingBack.slideContainer .modernSlide-enter-active{
  animation: slide-back-other ease-out .2s, slide-opacity linear .2s, slide-margin linear .2s;
}
.goingBack.slideContainer .modernSlide-leave-active{
  animation: slide-back ease-in .2s, slide-opacity reverse linear .2s, slide-margin reverse linear .2s;
}
@media (max-width: 780px) {
  .slideContainer {
    align-items: flex-start !important;
  }
}
</style>
